import { StockCard } from './IStockCard'

export interface IProductRequestProduct {
  productRequestProductId: number
  productId: number
  productName: string
  qty: number | string
  packagingId: string
  unit: string
  batchNumber: string
  premixId: string
  fillingAmount: number | string
  fillingUnit: string
}
export interface IProductRequest {
  productRequestId: string
  productRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  batchNumber: string
  premixId: string
  packagingId: string
  fillingAmount: number | string | null
  fillingUnit: string
  quantity: number | string | null
  stockCard: StockCard | null
  products: Partial<IProductRequestProduct>[]
  notes: string
  createdBy?: string
  createdAt: Date | string | null
  status?: string
}

export class ProductRequest implements IProductRequest {
  productRequestId: string
  productRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  batchNumber: string
  premixId: string
  packagingId: string
  fillingAmount: number | string | null
  fillingUnit: string
  quantity: number | string | null
  stockCard: StockCard | null
  products: Partial<IProductRequestProduct>[]
  notes: string
  createdBy?: string
  createdAt: Date | string | null
  status?: string

  constructor({
    productRequestId,
    productRequestDisplayId,
    inOutDirection,
    sourceOrDestination,
    batchNumber,
    premixId,
    packagingId,
    fillingAmount,
    fillingUnit,
    quantity,
    stockCard,
    products,
    notes,
    createdBy,
    createdAt,
    status,
  }: Partial<IProductRequest> = {}) {
    this.productRequestId = productRequestId ?? ''
    this.productRequestDisplayId = productRequestDisplayId ?? ''
    this.inOutDirection = inOutDirection ?? ''
    this.sourceOrDestination = sourceOrDestination ?? ''
    this.batchNumber = batchNumber ?? ''
    this.premixId = premixId ?? ''
    this.packagingId = packagingId ?? ''
    this.fillingAmount = fillingAmount ?? null
    this.fillingUnit = fillingUnit ?? ''
    this.quantity = quantity ?? null
    this.stockCard = stockCard ?? null
    this.products = products ?? []
    this.notes = notes ?? ''
    this.createdBy = createdBy ?? ''
    this.createdAt = createdAt ?? null
    this.status = status ?? ''
  }
}

export enum ProductRequestSourceOrDestination {
  rnd = 'RnD',
  qc = 'qc',
  // No-cost variants for incoming/outgoing
  noCostIn = 'Barang masuk tanpa biaya (wajib tulis notes dari siapa)',
  noCostOut = 'Barang di keluarkan tanpa biaya (wajib tulis notes untuk siapa)',
  fillingChangePackaging = 'filling - ganti kemasan',
  fillingRework = 'filling - rework',
  productionAdditionalRequest = 'produksi - additional request',
  sampleInhouse = 'Sample - In house',
  adjustment = 'adjustment',
  labelingAdditional = 'labeling: minta tambahan',
}
